module.exports = __webpack_public_path__ + "img/Dahlberg-12.66dde9f2.jpg";